import { Avatar, Text } from "@clipboard-health/ui-components";
import { Alert, Stack } from "@mui/material";

import { type ChosenFriend } from "./EligibleFriendChooser";

export interface ConfirmShiftTransferProps {
  transferee: ChosenFriend;
}

export function ConfirmTransferer(props: ConfirmShiftTransferProps) {
  const { transferee } = props;
  return (
    <Stack alignItems="center" spacing={7}>
      <Avatar
        src={transferee.attributes.profileImageUrl}
        fallbackText={
          transferee.attributes.firstName.slice(0, 1) + transferee.attributes.lastName.slice(0, 1)
        }
      />
      <Text variant="h5">
        Transfer to {transferee.attributes.firstName} {transferee.attributes.lastName}
      </Text>
      <Alert severity="warning" variant="filled">
        Are you sure you want to transfer this shift to {transferee.attributes.firstName}? If the
        transfer recipient cancels or No Call No Shows, you will lose 30 points. Transfer requests
        expire in 5 minutes. If they decline or the request expires, you can try transferring again.
      </Alert>
    </Stack>
  );
}
